import React, { memo, useCallback, useMemo } from 'react';
import EntityLink from 'components/EntityLink';
import { COMPANIES } from 'constants/Entities';
import DetailField from 'containers/components/EntityDetailPopover/DetailField';
import useEntityDetail from 'containers/components/EntityDetail/hooks/useEntityDetail';
import { stopEntityNavigation } from 'utils/entityNavigation';
import { canViewEntity } from 'utils/entityPermissions';
import { getCompanyDetailUrl } from 'utils/getUrl';

const CompanyField = memo(({ data, onClick }) => {
    const { hasTabsEnabled, openTab } = useEntityDetail();

    const handleOnClick = useCallback(
        (e) => {
            if (!canViewEntity(COMPANIES)) return stopEntityNavigation(e);
            if (!hasTabsEnabled || e.ctrlKey) return true;

            e.stopPropagation();
            e.preventDefault();

            onClick && onClick();

            openTab({
                entity: COMPANIES,
                id: data.IdCompany,
                hasCrudInDetail: true,
                toTab: false,
                avoidRedirects: true,
            });
        },
        [data.IdCompany, hasTabsEnabled, onClick, openTab],
    );

    const component = useMemo(() => {
        if (!data.empresa) return null;
        return (
            <EntityLink
                entity={COMPANIES}
                href={getCompanyDetailUrl(data.IdCompany)}
                onClick={handleOnClick}
                linkProps={{ className: 'fm-agenda-small-detail__link', target: 'blank' }}
                textProps={{ className: 'fm-agenda-small-detail__link' }}
            >
                {data.empresa}
            </EntityLink>
        );
    }, [data, handleOnClick]);

    if (!data.IdCompany || data.IdCompany === '-1') return null;

    return <DetailField iconProps={{ name: 'accounts' }} component={component} />;
});

export default CompanyField;
